import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { loadAndAssert } from '../authz/access.js';
import { Exam } from '../exam.js';

export const getExamTasksTreeQuery = registerQuery({
  operationName: 'getExamTasksTreeQuery',
  type: () => String,
  params: [{ name: 'examId', type: () => String }],

  resolve: (examId: string) => async (): Promise<string> => {
    await loadAndAssert(Exam, examId, 'read', { _id: 1 });
    const examCollection = await getCollection(Exam);
    const exam = await examCollection.findOne({ _id: examId });
    if (!exam) return JSON.stringify([]);

    const tasks = Array.isArray(exam.tasks) ? exam.tasks : [];
    return JSON.stringify(tasks);
  },
});

export const getExamAdditionalInfoQuery = registerQuery({
  operationName: 'getExamAdditionalInfoQuery',
  type: () => String,
  params: [{ name: 'examId', type: () => String }],

  resolve: (examId: string) => async (): Promise<string> => {
    await loadAndAssert(Exam, examId, 'read', { _id: 1 });
    const examCollection = await getCollection(Exam);
    const exam = await examCollection.findOne({ _id: examId });
    if (!exam) return JSON.stringify([]);

    const additionalInformation = Array.isArray(exam.additionalInformation) ? exam.additionalInformation : [];
    return JSON.stringify(additionalInformation);
  },
});
